import { render, staticRenderFns } from "./MessageLabel.vue?vue&type=template&id=929203cc&"
import script from "./MessageLabel.vue?vue&type=script&lang=js&"
export * from "./MessageLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports